module.exports = __webpack_public_path__ + "static/testi1-6438db75a6f2901c394ed7fb28dec2c8.jpg";